/**
 * Presentation of bucket roles and edge kinds (R23: the data declares meaning,
 * this view decides how it looks). Role colours reuse the report diagram
 * tokens so the printed report and this view agree.
 */
import { DIAGRAM_CLASS_STYLE } from '../../components/report/flowDiagram';
import { diagramPalette } from '../../constants/diagramPalette';
import type { BucketRole, ConsolidatedEdgeKind } from './types';

export interface RoleStyle { fill: string; stroke: string; text: string; label: string; dashed?: boolean }

const ROLE_TO_REPORT_CLASS: Record<BucketRole, string> = {
  subject: 'subject',
  depositors: 'victim',
  intermediaries: 'mule',
  exchange_offramp: 'cex',
  funding_exchange: 'cex',
  issuer: 'bridge',
  identities: 'notice',
  sources: 'target_wallet',
  context: 'spam',
};

export const ROLE_LABEL: Record<BucketRole, string> = {
  subject: 'Subject / hub',
  depositors: 'Depositors',
  intermediaries: 'Intermediaries',
  exchange_offramp: 'Exchange off-ramp',
  funding_exchange: 'Funding exchange',
  issuer: 'Issuer',
  identities: 'Identities',
  sources: 'Sources',
  context: 'Other wallets',
};

const PALETTE_ROLE: Partial<Record<BucketRole, string>> = {
  depositors: 'victim',
  intermediaries: 'mule',
  exchange_offramp: 'cex',
  funding_exchange: 'cex',
};

export function roleStyle(role: BucketRole): RoleStyle {
  const paletteKey = PALETTE_ROLE[role];
  const fromPalette = paletteKey ? diagramPalette[paletteKey] : undefined;
  const report = DIAGRAM_CLASS_STYLE[ROLE_TO_REPORT_CLASS[role] ?? 'spam'] ?? DIAGRAM_CLASS_STYLE.spam;
  const base: RoleStyle = fromPalette
    ? { fill: fromPalette.fill, stroke: fromPalette.stroke, text: fromPalette.text, label: report.label, dashed: Boolean(fromPalette.dash) }
    : report;
  return role === 'funding_exchange' ? { ...base, dashed: true } : base;
}

export interface EdgeKindStyle { color: string; dashed: boolean; curve: 'bezier' | 'straight' }

export const EDGE_KIND_STYLE: Record<ConsolidatedEdgeKind, EdgeKindStyle> = {
  deposit: { color: '#dc2626', dashed: false, curve: 'bezier' },
  sweep: { color: '#7c3aed', dashed: false, curve: 'bezier' },
  withdrawal: { color: '#ea580c', dashed: false, curve: 'bezier' },
  forward: { color: '#475569', dashed: false, curve: 'bezier' },
  identity_link: { color: '#16a34a', dashed: true, curve: 'bezier' },
  other: { color: '#94a3b8', dashed: true, curve: 'bezier' },
};
